// extracted by mini-css-extract-plugin
export default {"letterSquare":"LetterSquare_letterSquare__LqAuv","crossed":"LetterSquare_crossed__uKBN1","lineThrough":"LetterSquare_lineThrough__2P+bo","error":"LetterSquare_error__MBZu5"};